
'use strict'

if (process.env.NODE_ENV === 'production') {
  module.exports = require('./uneeq-react-ui.cjs.production.min.js')
} else {
  module.exports = require('./uneeq-react-ui.cjs.development.js')
}
